import { render, staticRenderFns } from "./CreateOrderDispatch.vue?vue&type=template&id=02a383aa&scoped=true&"
import script from "./CreateOrderDispatch.vue?vue&type=script&lang=js&"
export * from "./CreateOrderDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a383aa",
  null
  
)

export default component.exports